import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PolicyService } from 'src/app/_services/policy.service';
import { IPolicy } from 'src/app/_models/compliance';
import { MatTableDataSource } from '@angular/material/table';
import { User } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss'],
  providers: [DatePipe]
})
export class PolicyComponent implements OnInit {
  allPolicies: MatTableDataSource<IPolicy>
  displayedColumns = ["name", "type", "duration", "date", "active", "actions"];
  dialogData: IPolicyDialogData
  id: number
  currentUser: User
  currentDate: string
  date
  policyName: any
  policyCreated: boolean = false;
  policyUpdated: boolean = false;
  openPolicyForm: boolean = false
  jurisdictions = ["US"];
  policyId: number
  splitDuration
  years
  policiesCount: number
  noPolicies: boolean = false

  constructor(
    private policyService: PolicyService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private datePipe: DatePipe,
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }


  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) {
    this.sort = content;
    if (this.sort) {
      this.allPolicies.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.allPolicies.paginator = this.paginator;
    }
  }

  ngOnInit(): void {
    this.policyService.getPolicy().subscribe(policies => {
      if (policies == "No policies to display") {
        this.noPolicies = true
        this.allPolicies = null
      } else {
        this.allPolicies = new MatTableDataSource(policies);
        this.allPolicies.sort = this.sort;
        this.allPolicies.paginator = this.paginator;
        this.policiesCount = policies.length
        this.noPolicies = false
      }
    });
  }

  refreshPage() {
    this.ngOnInit();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.allPolicies.filter = filterValue.trim().toLowerCase();

    if (this.allPolicies.paginator) {
      this.allPolicies.paginator.firstPage();
    }
  }

  createPolicy(event) {
    this.openPolicyForm = true
    this.dialogData =
    {
      title: "Create Policy",
      button: "Create",
      name: "",
      description: "",
      jurisdiction: "US",
      type: "Duration",
      duration: {
        years: 0,
        months: 0,
        days: 0
      },
      date: ""
    };
    //console.log(this.dialogData)
  }

  createPolicyButton() {
    this.policyName = this.dialogData.name
    this.date = this.datePipe.transform(this.dialogData.date, 'MM/dd/yyyy');
    var policy =
    {
      name: this.dialogData.name,
      description: this.dialogData.description,
      jurisdiction:  "US",
      type: this.dialogData.type,
      duration: {
        years: this.dialogData.duration.years,
        months: this.dialogData.duration.months,
        days: this.dialogData.duration.days
      },
      date: this.date,
    };
    this.policyService.createPolicy(policy).subscribe(data => {
      this.policyCreated = true
      this.policyService.getPolicy().subscribe(policies => {
        this.allPolicies = new MatTableDataSource(policies);
        this.allPolicies.sort = this.sort;
        this.allPolicies.paginator = this.paginator;
      })
      this.dialogData.name = null;
      this.dialogData.description = null;
      this.dialogData.jurisdiction = null;
      this.dialogData.type = null;
      this.dialogData.date = null;
      this.dialogData.duration.years = null;
      this.dialogData.duration.months = null;
      this.dialogData.duration.days = null;
    },
      error => {
        console.log("Error", error)
        //alert("ERROR: " + error.message)
      }
    )
  }

  updatePolicyButton() {
    this.policyName = this.dialogData.name
    this.date = this.datePipe.transform(this.dialogData.date, 'MM/dd/yyyy');
    var updatedPolicy =
    {
      Id: this.policyId,
      name: this.dialogData.name,
      description: this.dialogData.description,
      jurisdiction: "US",
      type: this.dialogData.type,
      duration: {
        years: this.dialogData.duration.years,
        months: this.dialogData.duration.months,
        days: this.dialogData.duration.days
      },
      date: this.date,
    };
    this.policyService.updatePolicy(updatedPolicy).subscribe(data => {
      this.policyUpdated = true
      this.policyService.getPolicy().subscribe(policies => {
        this.allPolicies = new MatTableDataSource(policies);
        this.allPolicies.sort = this.sort;
        this.allPolicies.paginator = this.paginator;
      })
    },
      error => {
        console.log("Error")
        //alert("ERROR: " + error.error[0])
      }
    )
  }

  displayPage() {
    this.openPolicyForm = false
    this.back();
    this.refreshPage()
  }

  updatePolicy(event, policy) {
    this.openPolicyForm = true
    if (policy.type == "Duration") {
      this.splitDuration = (policy.duration).split(" ", 7)
      this.years = (this.splitDuration[1]).split("'", 2)
      // console.log(policy.duration)
      // console.log("Years", this.years[1])
      // console.log("Months", this.splitDuration[3])
      // console.log("Days", this.splitDuration[5])
      // policy.duration.years=parseInt(this.years[1])
      // policy.duration.months=parseInt(this.splitDuration[3])
      // policy.duration.days=parseInt(this.splitDuration[5])
      this.dialogData =
      {
        title: "Update Policy",
        button: "Update",
        name: policy.name,
        description: policy.description,
        jurisdiction:  "US",
        type: policy.type,
        duration: {
          years: parseInt(this.splitDuration[0]),
          months: parseInt(this.splitDuration[2]),
          days: parseInt(this.splitDuration[4]),
        },
        date: ""
      };
    }
    if (policy.type == "Fixed") {
      // policy.duration.years=0
      // policy.duration.months=0
      // policy.duration.days=0
      this.dialogData =
      {
        title: "Update Policy",
        button: "Update",
        name: policy.name,
        description: policy.description,
        jurisdiction: "US",
        type: policy.type,
        duration: {
          years: 0,
          months: 0,
          days: 0
        },
        date: policy.date
      };
    }
    this.policyId = policy.id
    //console.log(this.dialogData)
  }

  deletePolicy($event, id: number) {
    id
    console.log("DELETE", <number>id)
  }
  back() {
    this.policyCreated = false;
    this.policyUpdated = false
  }

}

export interface IPolicyDialogData {
  title: string;
  button: string;
  name: string;
  description: string;
  jurisdiction: string;
  type: string;
  duration: {
    years: number;
    months: number;
    days: number;
  };
  date: string;
}

@Component({
  selector: 'policy-dialog',
  templateUrl: 'policy-dialog.html',
  styleUrls: ['policy-dialog.css']
})
export class PolicyDialog {

  constructor(
    public dialogRef: MatDialogRef<PolicyDialog>,
    @Inject(MAT_DIALOG_DATA) public data: IPolicyDialogData) { }

  //policyTypes = ["Duration", "Fixed", "Rest"];
  jurisdictions = ["India", "Patiala", "USA", "US", "USI", "Ohio"];
  //durations = ["1 day", "2 days", "1 week", "2 weeks", "1 month", "2 months", "1 year", "2 years"];

  onNoClick(): void {
    this.dialogRef.close();
  }

}